const terms = {}

export type LocaleTerms = typeof terms

export default terms
